import { BeachLine } from '@/entities/hotel';
import { ProductType } from '@/shared/config/pages';
import { FilterGroupId, type SerpFilterGroupId, type SerpSort } from '../model/types';

export const SERP_DATA_LAYER_BANNERS_STEP = 5;

export const SERP_DATA_LAYER_MAX_STEP = 1;

export const SERP_DATA_LAYER_FILTER_PAGES: Partial<Record<ProductType, string>> = {
  [ProductType.TourOffer]: 'searchPage',
};

export interface SerpDataLayerFilterOption {
  value: string;
  sideBar?: string;
}

export interface SerpDataLayerFilterGroup {
  radio: boolean;
  any: SerpDataLayerFilterOption;
  options: Readonly<Record<string, SerpDataLayerFilterOption>>;
}

export const SERP_DATA_LAYER_FILTER_GROUPS: Readonly<Partial<Record<SerpFilterGroupId, SerpDataLayerFilterGroup>>> = {
  [FilterGroupId.BeachLine]: {
    radio: false,
    any: { value: 'Линия пляжа_Не важно', sideBar: 'beach_line_any' },
    options: {
      [BeachLine.First]: { value: 'Линия пляжа_1-я линия', sideBar: 'beach_line_1' },
      [BeachLine.Second]: { value: 'Линия пляжа_2-я линия', sideBar: 'beach_line_2' },
      [BeachLine.Third]: { value: 'Линия пляжа_3-я линия', sideBar: 'beach_line_3' },
    },
  },
  [FilterGroupId.BeachOwner]: {
    radio: true,
    any: { value: 'Пляж_Не важно', sideBar: 'beach_owner' },
    options: {
      [FilterGroupId.BeachOwner]: { value: 'Пляж_Собственный пляж отеля', sideBar: 'beach_owner' },
    },
  },
  [FilterGroupId.Rating]: {
    radio: true,
    any: { value: 'Оценка по отзывам_Все отели' },
    options: {
      best: { value: 'Оценка по отзывам_Превосходно' },
      better: { value: 'Оценка по отзывам_Очень хорошо' },
      good: { value: 'Оценка по отзывам_Хорошо' },
    },
  },
};

export const SERP_DATA_LAYER_SORT_VALUES: Readonly<Record<SerpSort, string>> = {
  popular: 'Сотрировка_Популярные',
  priceAsc: 'Сотрировка_Сначала дешевые',
  priceDesc: 'Сотрировка_Сначала дорогие',
  rating: 'Сотрировка_По оценкам',
};
